export const environment = {
  production: true,
  serviceWorker: true,
  processPageSize: 10,
  VERSION: '1.0.0',
  name: 'production',
  faceReconKey: '285839e3-676a-46b5-88d8-7bd06ebc4c2f',
  siteUrl: 'https://app.buildflex.io',
  apiUrl: 'https://api.buildflex.io',
  googleMapsApiKey: 'AIzaSyBusJL_U8aeKM1UxwU5OxkO4hO9E296oSM'
};
